"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.lazyGetter = lazyGetter;
function lazyGetter(target, key, getter) {
  var config = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  Object.defineProperty(target, key, {
    configurable: true,
    enumerable: config.enumerable !== false,
    get() {
      var val = getter();
      Object.defineProperty(target, key, {
        value: val,
        writable: Boolean(config.writable),
        configurable: false
      });
      return val;
    }
  });
  return target;
}

//
// const o = lazyGetter({}, 'expensive', function() {
//   console.log('doing expensive calculations')
//   return 'RESULT OF EXPENSIVE'
// })
//
// console.log(o.expensive)
// console.log(o.expensive)
// console.log(o.expensive)